(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6030],{

/***/ 92634:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/allied-services/[slug]",
      function () {
        return __webpack_require__(56227);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/AlliedServices/AlliedServices.module.scss
var AlliedServices_module = __webpack_require__(36257);
var AlliedServices_module_default = /*#__PURE__*/__webpack_require__.n(AlliedServices_module);
// EXTERNAL MODULE: ./components/AlliedServices/HeroSection/HeroSection.module.scss
var HeroSection_module = __webpack_require__(75900);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./components/EnquiryModal/LeadGenForms.tsx + 2 modules
var LeadGenForms = __webpack_require__(59833);
// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
;// CONCATENATED MODULE: ./components/AlliedServices/HeroSection/HeroSection.tsx







const HeroSection = ({ alliedServiceData  })=>{
    const heroSectionData = alliedServiceData?.heroSection ?? {};
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const isTab = (0,useIsMobile/* default */.Z)(1024);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "hero-section",
        className: (HeroSection_module_default())["hero-section-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                className: (HeroSection_module_default())["hero-picture"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        media: "(max-width: 767px)",
                        srcSet: heroSectionData?.backgroundImg?.url ?? ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: heroSectionData?.backgroundImg?.url ?? "",
                        loading: "eager",
                        fetchPriority: "high",
                        decoding: "async",
                        width: "100%",
                        height: "100%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HeroSection_module_default())["content-form-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeroSection_module_default())["content-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeroSection_module_default())["breadcrum-container"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                            style: {
                                                opacity: 0.5
                                            },
                                            href: "/",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                            href: "",
                                            className: (HeroSection_module_default())["breadcrumb-item-2"],
                                            children: alliedServiceData?.title
                                        })
                                    ]
                                })
                            }),
                            heroSectionData?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (HeroSection_module_default()).heading,
                                children: heroSectionData?.title
                            }),
                            heroSectionData?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeroSection_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: heroSectionData?.description
                                }
                            }),
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeroSection_module_default())["feature-container"],
                                children: heroSectionData?.feature?.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (HeroSection_module_default()).feature,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (HeroSection_module_default())["icon-container"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: feature?.icon?.url ?? "",
                                                    height: 20,
                                                    width: 20,
                                                    alt: "left-arrow"
                                                })
                                            }),
                                            feature?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (HeroSection_module_default())["feature-title"],
                                                dangerouslySetInnerHTML: {
                                                    __html: feature.title
                                                }
                                            })
                                        ]
                                    }))
                            })
                        ]
                    }),
                    !isTab && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `${(HeroSection_module_default())["form-container"]}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (HeroSection_module_default())["form-heading"],
                                children: "Need help with Loan, Forex, Money Transfer or Accommodation?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGenForms/* default */.Z, {
                                mode: "inline",
                                url: "https://crm-staging.coursefinder.ai" + "/" + (alliedServiceData?.heroSection?.formId ?? ""),
                                wrapperClass: (HeroSection_module_default()).inLineFormUniversity,
                                loader: "shimmer"
                            })
                        ]
                    })
                ]
            }),
            (isMobile || isTab) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(HeroSection_module_default())["form-container"]}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (HeroSection_module_default())["form-heading"],
                        children: "Need help with Loan, Forex, Money Transfer or Accommodation?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGenForms/* default */.Z, {
                        mode: "inline",
                        url: "https://crm-staging.coursefinder.ai" + "/" + (alliedServiceData?.heroSection?.formId ?? ""),
                        wrapperClass: (HeroSection_module_default()).inLineFormUniversity,
                        loader: "shimmer"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HeroSection_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./components/AlliedServices/HighlightSection/HighlightSection.module.scss
var HighlightSection_module = __webpack_require__(14486);
var HighlightSection_module_default = /*#__PURE__*/__webpack_require__.n(HighlightSection_module);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./components/AlliedServices/HighlightSection/HighlightSection.tsx









const Card = ({ iconUrl , title , description  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HighlightSection_module_default())["card-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HighlightSection_module_default())["icon-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                    src: iconUrl ?? "",
                    width: 22,
                    height: 22,
                    alt: "icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (HighlightSection_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (HighlightSection_module_default()).description,
                children: description
            })
        ]
    });
};
const IconContainer = ({ url  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HighlightSection_module_default())["icon-container"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
            src: url ?? "",
            width: 19,
            height: 19,
            alt: "icon"
        })
    });
};
const HighlightSection = ({ featureShowcaseData  })=>{
    const router = (0,next_router.useRouter)();
    const isMobile = (0,useIsMobile/* default */.Z)(1350);
    const card1Data = featureShowcaseData?.highlightedCard?.[0];
    const card2Data = featureShowcaseData?.highlightedCard?.[1];
    const card3Data = featureShowcaseData?.highlightedCard?.[2];
    const card4Data = featureShowcaseData?.highlightedCard?.[3];
    const card5Data = featureShowcaseData?.highlightedCard?.[4];
    const card6Data = featureShowcaseData?.highlightedCard?.[5];
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: featureShowcaseData?.button?.link,
        formId: featureShowcaseData?.button?.formId,
        toOnboardingEnabled: featureShowcaseData?.button?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: featureShowcaseData?.button?.nearestOffice ?? true,
                    coachingVisible: featureShowcaseData?.button?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (HighlightSection_module_default())["highlight-section-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HighlightSection_module_default())["content-container"],
                    children: [
                        featureShowcaseData?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (HighlightSection_module_default()).title,
                            children: featureShowcaseData?.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ctaBtnClickHandler(applyCtaButtonProps),
                            className: `${applyCtaButtonProps.formClassName} ${(HighlightSection_module_default())["enquire-now-btn"]}`,
                            children: featureShowcaseData?.button?.title || "Enquire Now"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HighlightSection_module_default())["orbit-3"],
                            children: featureShowcaseData?.orbit3Icons?.length > 0 && featureShowcaseData?.orbit3Icons?.map((icon, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: `${(HighlightSection_module_default())[`icon-${index + 1}-container`]}`,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                        url: icon.url ?? ""
                                    })
                                }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HighlightSection_module_default())["card-1-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                iconUrl: card5Data?.icon?.url,
                                title: card5Data?.title,
                                description: card5Data?.description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HighlightSection_module_default())["card-2-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                iconUrl: card6Data?.icon?.url,
                                title: card6Data?.title,
                                description: card6Data?.description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HighlightSection_module_default())["card-3-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                iconUrl: card1Data?.icon?.url,
                                title: card1Data?.title,
                                description: card1Data?.description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HighlightSection_module_default())["card-4-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                iconUrl: card2Data?.icon?.url,
                                title: card2Data?.title,
                                description: card2Data?.description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HighlightSection_module_default())["card-5-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                iconUrl: card3Data?.icon?.url,
                                title: card3Data?.title,
                                description: card3Data?.description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HighlightSection_module_default())["card-6-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                iconUrl: card4Data?.icon?.url,
                                title: card4Data?.title,
                                description: card4Data?.description
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HighlightSection_module_default())["orbit-1"],
                    children: featureShowcaseData?.orbit1Icons?.length > 0 && featureShowcaseData?.orbit1Icons?.map((icon, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(HighlightSection_module_default())[`icon-${index + 1}-container`]}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                url: icon.url ?? ""
                            })
                        }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HighlightSection_module_default())["orbit-2"],
                    children: featureShowcaseData?.orbit2Icons?.length > 0 && featureShowcaseData?.orbit2Icons?.map((icon, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(HighlightSection_module_default())[`icon-${index + 1}-container`]}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                url: icon.url ?? ""
                            })
                        }))
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (HighlightSection_module_default())["highlight-section-container-mobile"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (HighlightSection_module_default()).title,
                    children: featureShowcaseData?.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HighlightSection_module_default())["cards-container"],
                    children: featureShowcaseData?.highlightedCard?.map((card, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `${(HighlightSection_module_default()).card} ${(HighlightSection_module_default())[`card-${index + 1}`]}`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HighlightSection_module_default())["icon-container"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        width: 22,
                                        height: 22,
                                        src: card?.icon?.url,
                                        alt: card?.icon?.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: (HighlightSection_module_default()).title,
                                    children: card?.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (HighlightSection_module_default()).description,
                                    children: card?.description
                                })
                            ]
                        }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ctaBtnClickHandler(applyCtaButtonProps),
                    className: `${applyCtaButtonProps.formClassName} ${(HighlightSection_module_default())["enquire-now-btn"]}`,
                    children: featureShowcaseData?.button?.title || "Enquire Now"
                })
            ]
        })
    });
};
/* harmony default export */ var HighlightSection_HighlightSection = (HighlightSection);

// EXTERNAL MODULE: ./components/AlliedServices/Vendors/Vendors.module.scss
var Vendors_module = __webpack_require__(16444);
var Vendors_module_default = /*#__PURE__*/__webpack_require__.n(Vendors_module);
// EXTERNAL MODULE: ./components/UI/Dropdown/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(20052);
// EXTERNAL MODULE: ./components/AlliedServices/Vendors/VendorCard/VendorCard.module.scss
var VendorCard_module = __webpack_require__(88908);
var VendorCard_module_default = /*#__PURE__*/__webpack_require__.n(VendorCard_module);
// EXTERNAL MODULE: ./components/UI/Icons/TickMark.tsx
var TickMark = __webpack_require__(81945);
;// CONCATENATED MODULE: ./components/UI/Icons/InfoIcon.tsx


const InfoIcon = ({ width =16 , height =16 , color ="#868697"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_13240_3793)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.99923 10.6668V7.99996M7.99923 5.33308H8.0059M14.6664 7.99996C14.6664 11.6822 11.6814 14.6672 7.99923 14.6672C4.31704 14.6672 1.33203 11.6822 1.33203 7.99996C1.33203 4.31777 4.31704 1.33276 7.99923 1.33276C11.6814 1.33276 14.6664 4.31777 14.6664 7.99996Z",
                    stroke: color,
                    "stroke-width": "2",
                    "stroke-linecap": "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_13240_3793",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_InfoIcon = (InfoIcon);

;// CONCATENATED MODULE: ./components/AlliedServices/Vendors/VendorCard/VendorCard.tsx










const DESTINATION_CHIPS_COLLAPSED_COUNT = 6;
const VendorDestinationChips = ({ destinations  })=>{
    const { 0: isExpanded , 1: setIsExpanded  } = (0,react.useState)(false);
    const hiddenCount = destinations?.length - DESTINATION_CHIPS_COLLAPSED_COUNT;
    const visibleDestinations = isExpanded ? destinations : destinations?.slice(0, DESTINATION_CHIPS_COLLAPSED_COUNT);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (VendorCard_module_default())["destination-chips"],
        children: [
            visibleDestinations.map((destination)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (VendorCard_module_default())["destination-chip"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: destination?.imageUrl ?? "",
                            width: 16,
                            height: 12,
                            alt: destination?.name,
                            objectFit: "cover"
                        }),
                        destination?.name
                    ]
                }, destination.id)),
            hiddenCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (VendorCard_module_default())["more-toggle"],
                onClick: ()=>setIsExpanded((prev)=>!prev),
                children: isExpanded ? "Show less" : `+${hiddenCount} More`
            })
        ]
    });
};
const VendorCard = ({ vendor , onLearnMore , onEnquireNow  })=>{
    const router = (0,next_router.useRouter)();
    const enquireNowButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: vendor?.cardDetails?.enquireButton?.link,
        formId: vendor?.cardDetails?.enquireButton?.formId,
        toOnboardingEnabled: vendor?.cardDetails?.enquireButton?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (buttonProps, receivedData)=>(e)=>{
            if (buttonProps.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: receivedData?.button?.nearestOffice ?? true,
                    coachingVisible: receivedData?.button?.lookingForCoaching ?? true
                });
            }
            buttonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (VendorCard_module_default())["vendor-card"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VendorCard_module_default())["part-1"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VendorCard_module_default())["vendor-badge"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: vendor?.logo?.url ?? "",
                            width: 244,
                            height: 72,
                            alt: vendor?.logo?.name ?? "",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (VendorCard_module_default())["card-title"],
                        children: vendor?.cardDetails?.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VendorCard_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VendorCard_module_default())["promotions-header"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (VendorCard_module_default())["promotions-label"],
                                children: vendor?.cardDetails?.promotionsAndFeatures?.title
                            }),
                            vendor?.cardDetails?.additionalInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (VendorCard_module_default())["info-tooltip-wrapper"],
                                tabIndex: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_InfoIcon, {
                                        width: 16,
                                        height: 16,
                                        color: "#64647A"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (VendorCard_module_default())["info-tooltip-box"],
                                        role: "tooltip",
                                        children: vendor?.cardDetails?.additionalInfo
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (VendorCard_module_default())["promotions-list"],
                        children: vendor?.cardDetails?.promotionsAndFeatures?.features?.length > 0 && vendor?.cardDetails?.promotionsAndFeatures?.features?.map((promotion)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (VendorCard_module_default())["promotions-item"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (VendorCard_module_default())["check-circle"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TickMark/* default */.Z, {
                                            width: 10,
                                            height: 10,
                                            color: "#226CF5"
                                        })
                                    }),
                                    promotion?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: promotion.title
                                        }
                                    })
                                ]
                            }, promotion.id))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (VendorCard_module_default())["destinations-label"],
                        children: vendor?.cardDetails?.destinationHeading ?? "Available for these destinations:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VendorDestinationChips, {
                        destinations: vendor.countries
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VendorCard_module_default())["part-2"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VendorCard_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VendorCard_module_default())["card-actions"],
                        children: [
                            vendor?.cardDetails?.learnMoreButton?.link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: vendor?.cardDetails?.learnMoreButton?.link ?? `${window.location.pathname}/${vendor?.slug}`,
                                className: (VendorCard_module_default())["learn-more-btn"],
                                onClick: onLearnMore ? ()=>onLearnMore(vendor) : undefined,
                                target: "_blank",
                                children: "Learn more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: `${(VendorCard_module_default())["enquire-now-btn"]} ${enquireNowButtonProps.formClassName}`,
                                onClick: (e)=>{
                                    onEnquireNow?.(vendor);
                                    ctaBtnClickHandler(enquireNowButtonProps, vendor?.cardDetails?.enquireButton)?.(e);
                                },
                                children: "Enquire Now"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (VendorCard_module_default()).disclaimer,
                        children: vendor?.cardDetails?.disclaimerText ?? "*subject to conditions"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var VendorCard_VendorCard = (VendorCard);

;// CONCATENATED MODULE: ./components/AlliedServices/Vendors/Vendors.tsx





const Vendors = ({ vendorsData , vendorsSectionData , destinationOptions =[] , initialVisibleCount =6 , viewMoreStep =6 , onDestinationChange , onLearnMore , onEnquireNow  })=>{
    const { 0: selectedDestination , 1: setSelectedDestination  } = (0,react.useState)(null);
    const { 0: visibleCount , 1: setVisibleCount  } = (0,react.useState)(initialVisibleCount);
    const { 0: vendors , 1: setVendors  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setVendors(vendorsData ?? []);
        setSelectedDestination(null);
        setVisibleCount(initialVisibleCount);
    }, [
        vendorsData
    ]);
    const handleDestinationChange = (option)=>{
        const filtered = (vendorsData ?? []).filter((vendor)=>vendor?.countries?.some((country)=>country?.name?.toLowerCase() === option.value.toLowerCase()));
        setVendors(filtered);
        setSelectedDestination(option);
        setVisibleCount(initialVisibleCount);
        onDestinationChange?.(option);
    };
    const handleDestinationClear = ()=>{
        setSelectedDestination(null);
        setVendors(vendorsData ?? []);
        setVisibleCount(initialVisibleCount);
        onDestinationChange?.(null);
    };
    const visibleVendors = vendors.slice(0, visibleCount);
    const hasMore = vendors.length > visibleCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Vendors_module_default())["vendors-section"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Vendors_module_default())["header-container"],
                children: [
                    vendorsSectionData?.subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Vendors_module_default()).eyebrow,
                        children: vendorsSectionData.subHeading
                    }),
                    vendorsSectionData?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (Vendors_module_default()).title,
                        children: vendorsSectionData.title
                    }),
                    vendorsSectionData?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Vendors_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: vendorsSectionData.description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Vendors_module_default())["dropdown-container"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                            options: destinationOptions,
                            value: selectedDestination,
                            onChange: handleDestinationChange,
                            onClear: handleDestinationClear,
                            showClear: true,
                            placeholder: "Choose your Destination",
                            className: (Vendors_module_default())["destination-dropdown"],
                            searchable: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Vendors_module_default())["vendors-grid"],
                children: visibleVendors && visibleVendors?.length > 0 && visibleVendors.map((vendor)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(VendorCard_VendorCard, {
                        vendor: vendor,
                        onLearnMore: onLearnMore,
                        onEnquireNow: onEnquireNow
                    }, vendor.id))
            }),
            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Vendors_module_default())["view-more-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (Vendors_module_default())["view-more-btn"],
                    onClick: ()=>setVisibleCount((prev)=>prev + viewMoreStep),
                    children: "View More"
                })
            })
        ]
    });
};
/* harmony default export */ var Vendors_Vendors = (Vendors);

// EXTERNAL MODULE: ./components/AlliedServices/SuggestedServices/SuggestedServices.tsx
var SuggestedServices = __webpack_require__(13488);
// EXTERNAL MODULE: ./components/AlliedServices/FAQs/FAQs.tsx
var FAQs = __webpack_require__(64014);
// EXTERNAL MODULE: ./components/AlliedServices/Banner/AdBanner.tsx
var AdBanner = __webpack_require__(84959);
;// CONCATENATED MODULE: ./components/AlliedServices/AlliedServices.tsx









const AlliedServices = (props)=>{
    const alliedServiceData = props?.pageData?.[0] ?? {};
    const alliedServicesCardData = props?.alliedServicesCardData ?? {};
    const countriesList = props?.countriesList ?? [];
    const { featureShowcase , vendors , vendorsSection , faq , banner , serviceSuggestion  } = alliedServiceData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (AlliedServices_module_default())["allied-services-section"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                alliedServiceData: alliedServiceData
            }),
            featureShowcase && /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightSection_HighlightSection, {
                featureShowcaseData: featureShowcase
            }),
            vendors?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Vendors_Vendors, {
                vendorsData: vendors,
                vendorsSectionData: vendorsSection,
                destinationOptions: countriesList?.map((country)=>({
                        label: country.name,
                        value: country.name
                    }))
            }),
            alliedServicesCardData && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedServices/* default */.Z, {
                heading: serviceSuggestion?.title,
                subtext: serviceSuggestion?.description,
                alliedServicesCardData: alliedServicesCardData,
                excludeCurrentSlug: true
            }),
            faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {
                faqData: faq
            }),
            banner && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBanner/* default */.Z, {
                bannerData: banner
            })
        ]
    });
};
/* harmony default export */ var AlliedServices_AlliedServices = (AlliedServices);

// EXTERNAL MODULE: ./components/ErrorComponent.tsx
var ErrorComponent = __webpack_require__(46412);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/student-services/allied-services/[slug].tsx





const AlliedServicesDetail = (props)=>{
    if (!props.pageData || props.pageData.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent/* default */.Z, {});
    }
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6c48f0");
        customStyle.setProperty("--navbar-menu-color", "#FFFFFF");
    }, []);
    const meta = props.pageData[0]?.meta;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta,
                canonicalUrl: `${"https://staging.studies-overseas.com"}/student-services/allied-services/${props.slug}`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlliedServices_AlliedServices, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (AlliedServicesDetail);


/***/ }),

/***/ 36257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"AlliedServices_hide-scrollbar__pPQtg","allied-services-section":"AlliedServices_allied-services-section__EhbmX"};

/***/ }),

/***/ 75900:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HeroSection_hide-scrollbar__CWyZs","hero-section-container":"HeroSection_hero-section-container__uuwod","hero-picture":"HeroSection_hero-picture__NT7Ny","content-form-container":"HeroSection_content-form-container__Db37k","content-container":"HeroSection_content-container__nvz0v","breadcrum-container":"HeroSection_breadcrum-container__uUNKT","heading":"HeroSection_heading__qNOQO","description":"HeroSection_description__kueB_","feature-container":"HeroSection_feature-container__L5Ima","feature":"HeroSection_feature__qFaNO","icon-container":"HeroSection_icon-container__XmMdH","feature-title":"HeroSection_feature-title__ZaWwl","form-container":"HeroSection_form-container__A5HSy","form-heading":"HeroSection_form-heading__ztHTr","inLineFormUniversity":"HeroSection_inLineFormUniversity__GMqIr"};

/***/ }),

/***/ 14486:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HighlightSection_hide-scrollbar__vdClh","highlight-section-container":"HighlightSection_highlight-section-container__PCfsj","content-container":"HighlightSection_content-container__Uh_9L","title":"HighlightSection_title__BTqXM","enquire-now-btn":"HighlightSection_enquire-now-btn__qjm1a","card-1-container":"HighlightSection_card-1-container__0SBXJ","card-2-container":"HighlightSection_card-2-container__NJAih","card-3-container":"HighlightSection_card-3-container__6gb6T","card-4-container":"HighlightSection_card-4-container__ykDPq","card-5-container":"HighlightSection_card-5-container__IYJKo","card-6-container":"HighlightSection_card-6-container__ryYvM","card-container":"HighlightSection_card-container__Tu4mg","icon-container":"HighlightSection_icon-container__Ix0kI","description":"HighlightSection_description__MBXVL","orbit-1":"HighlightSection_orbit-1__N8bX2","icon-1-container":"HighlightSection_icon-1-container__pFX6Z","icon-2-container":"HighlightSection_icon-2-container__kckZz","orbit-2":"HighlightSection_orbit-2__lqVZH","icon-3-container":"HighlightSection_icon-3-container__JwdI8","icon-4-container":"HighlightSection_icon-4-container__Ga3Nj","orbit-3":"HighlightSection_orbit-3___btML","highlight-section-container-mobile":"HighlightSection_highlight-section-container-mobile__RlIKG","cards-container":"HighlightSection_cards-container__0GUqK","card":"HighlightSection_card__2yZNg","card-2":"HighlightSection_card-2__gbglT","card-3":"HighlightSection_card-3__J1_z7","card-4":"HighlightSection_card-4__k5tRK","card-5":"HighlightSection_card-5__8wOIQ","card-6":"HighlightSection_card-6__vrAnE"};

/***/ }),

/***/ 88908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"VendorCard_hide-scrollbar__87Vbg","vendor-card":"VendorCard_vendor-card__aRClW","vendor-badge":"VendorCard_vendor-badge__Ud9gT","card-title":"VendorCard_card-title__CrWMZ","divider":"VendorCard_divider__PUQr2","promotions-header":"VendorCard_promotions-header__bH6Nm","promotions-label":"VendorCard_promotions-label__DSt9y","info-tooltip-wrapper":"VendorCard_info-tooltip-wrapper__v30cu","info-tooltip-box":"VendorCard_info-tooltip-box__WCFyE","promotions-list":"VendorCard_promotions-list__gJ6jn","promotions-item":"VendorCard_promotions-item__cZJf_","check-circle":"VendorCard_check-circle__Nsln8","destinations-label":"VendorCard_destinations-label__J5Po3","destination-chips":"VendorCard_destination-chips__SViXu","destination-chip":"VendorCard_destination-chip__b9APG","more-toggle":"VendorCard_more-toggle__3i4Ut","card-actions":"VendorCard_card-actions__DGJoF","learn-more-btn":"VendorCard_learn-more-btn__bAsw4","enquire-now-btn":"VendorCard_enquire-now-btn__RU1rW","disclaimer":"VendorCard_disclaimer__DBZKg"};

/***/ }),

/***/ 16444:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Vendors_hide-scrollbar___dc7P","vendors-section":"Vendors_vendors-section__VD_1m","header-container":"Vendors_header-container___xZ0b","eyebrow":"Vendors_eyebrow__y4_XC","title":"Vendors_title__ij5q_","description":"Vendors_description__p4Mks","dropdown-container":"Vendors_dropdown-container__nfNdw","destination-dropdown":"Vendors_destination-dropdown__n6pHE","vendors-grid":"Vendors_vendors-grid__ys7U1","view-more-container":"Vendors_view-more-container__WDce8","view-more-btn":"Vendors_view-more-btn__EGDC0"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9382,6985,8709,9774,2888,179], function() { return __webpack_exec__(92634); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);